module.exports = __webpack_public_path__ + "img/spark.a5e30ea4.svg";